<kendo-splitter orientation="vertical">
  <kendo-splitter-pane [scrollable]="false" size="500px">
    <app-vehicle-service-grid
      *ngIf="model"
      height="100%"
      width="auto"
      [vehicleId]="model.id"
      (mySelected)="grid_onSelected($event)"></app-vehicle-service-grid>
  </kendo-splitter-pane>

  <kendo-splitter-pane [collapsible]="true" [scrollable]="false" size="500px">
    <app-vehicle-service-details-tabs [vehicleService]="selected$ | async"></app-vehicle-service-details-tabs>
  </kendo-splitter-pane>
  <kendo-splitter-pane [collapsible]="true" [scrollable]="false"> </kendo-splitter-pane>
</kendo-splitter>
